import React, { Component } from "react";

import constants from "../constants";
import CloseButton from "./closeButton";
import "./settingsPane.scss";

class SettingsPane extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settings: Object.fromEntries(
        constants.settings
          .filter((x) => x.toggleable)
          .map((setting) => [setting.key, localStorage.getItem(setting.key)])
      ),
    };
  }

  render() {
    return (
      <div className="SettingsPane">
        <CloseButton />
        <h2>Settings</h2>
        {constants.settings
          .filter((x) => x.toggleable)
          .map((setting) => (
            <div className="setting-item" key={setting.key}>
              <p className="setting-name">
                {setting.name === undefined ? setting.key : setting.name}
              </p>
              <div className="slider-container">
                <p>
                  {setting.lowLabel === undefined ? "Less" : setting.lowLabel}
                </p>
                <input
                  type="range"
                  min="1"
                  max="100"
                  value={
                    ((this.state.settings[setting.key] - setting.lowValue) /
                      (setting.highValue - setting.lowValue)) *
                    100
                  }
                  onChange={(e) => {
                    const newValue =
                      (e.target.value / 100) *
                        (setting.highValue - setting.lowValue) +
                      setting.lowValue;

                    const settings = this.state.settings;
                    settings[setting.key] = newValue;

                    this.setState({
                      settings,
                    });

                    localStorage.setItem(setting.key, newValue);
                  }}
                />
                <p>
                  {setting.highLabel === undefined ? "More" : setting.highLabel}
                </p>
              </div>
            </div>
          ))}
      </div>
    );
  }
}

export default SettingsPane;
